// extracted by css-extract-rspack-plugin
export default {"root":"D3hkn","pivotedFirstColumn":"Ov8ag","bodyCellWithImage":"jlIkS"};